import { render, staticRenderFns } from "./FeaturedDestinations.vue?vue&type=template&id=89fd027e"
import script from "./FeaturedDestinations.vue?vue&type=script&lang=js"
export * from "./FeaturedDestinations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports